'use strict';

var novicell = novicell || {};
// Lazysizes config
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 1000;

novicell.lazyload = novicell.lazyload || function (image) {

    if(image.src) {
        return;
    }

    var target = image;
    var setMeasuredUrl = target.classList.contains('lazyload-measure');
    var url, src, query;

    if (setMeasuredUrl) {
        var setBg = target.classList.contains('lazyload-bg');
        url = novicell.dynamicImage.getUrl(target);

        if (setBg) {
            target.parentNode.style.backgroundImage = 'url(' + url + ')';
        } else {
            target.src = url;
        }

    } else if (target.hasAttribute('data-srcset') && target.hasAttribute('data-query-obj')) {
        var srcset = target.getAttribute('data-srcset').split(",");
        var newSrcset = [];
        query = target.getAttribute('data-query-obj');
        src = target.getAttribute('data-src');

        srcset.forEach(function (src) {
            src = src.trim();
            src = src.split(' ');

            var url = src[0];
            var bp = src[1];
            var newSrc = novicell.dynamicImage.queryUrl(url, query);
            // set new srcset
            newSrcset.push(newSrc + ' ' + bp);
        });

        target.setAttribute('srcset', newSrcset.join(', '));
        target.setAttribute('src', novicell.dynamicImage.queryUrl(src, query));
    } else if (target.hasAttribute('data-src')) {
        query = target.getAttribute('data-query-obj');
        src = target.getAttribute('data-src');
        url = novicell.dynamicImage.queryUrl(src, query);

        target.setAttribute('src', url);
    }
};

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function elementInViewport(element, expandMargin) {
    var extraMargin = expandMargin || 200;
    var currentWindowHeight = window.innerHeight;
    var rect = element.getBoundingClientRect();
    var span = rect.top + rect.height + extraMargin;

    return (span >= Math.min(0, extraMargin) && rect.top <= currentWindowHeight + extraMargin);
}

/*
var lastRefreshWidth = 0;
var refreshWidth = 50;
var checkImages = debounce(function () {
    if (window.innerWidth > lastRefreshWidth + refreshWidth || window.innerWidth < lastRefreshWidth - refreshWidth) {
        var loadedElements = document.body.querySelectorAll('.lazyloaded');
        loadedElements.forEach(function (el) {
            el.classList.remove('lazyloaded');
            el.classList.add('lazyload');
        });
        lastRefreshWidth = window.innerWidth;
    }
}, 100, false);
*/

//window.addEventListener('resize', checkImages);


novicell.loadImagesInView = debounce(function(){

    novicell.lazyImages = document.body.querySelectorAll('.lazyload');

    for (var i = 0; i < novicell.lazyImages.length; i++) {
        var lazyImage = novicell.lazyImages[i];
        if(elementInViewport(lazyImage) && !lazyImage.classList.contains("lazyloaded")) {
            novicell.lazyload(lazyImage);
        }
    }
}, 50, false);

novicell.loadImagesInView();
window.addEventListener('load', function() {
    window.addEventListener('scroll', novicell.loadImagesInView, false);
    window.addEventListener('resize', novicell.loadImagesInView, false);
});


